import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, watchEffect } from "vue";
  import router from "@/router";
  import { NavigationItem as OriginalNavigationItem } from "@/types";
  import store from "@/store";
  import { hasRequiredTier } from "@/helpers/getUserTier";

  type NavigationItem = OriginalNavigationItem & { canAccess?: boolean };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BottomNavigationComponent',
  props: {
    navigation: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const { navigation } = toRefs(props);
  const userData = computed(() => store.state.user.data);
  const navigationWithAccess = ref<NavigationItem[]>([]);

  const accessibleItemsCount = computed(() => {
    return navigationWithAccess.value.filter((item) => item.canAccess).length;
  });

  watchEffect(() => {
    if (!navigation.value || navigation.value.length === 0) {
      navigationWithAccess.value = [];
      return;
    }

    Promise.all(
      navigation.value.map(async (item) => ({
        ...item,
        canAccess: item.requiredTier
          ? await hasRequiredTier(userData.value, item.requiredTier)
          : true,
      }))
    ).then((nav) => {
      navigationWithAccess.value = nav;
    });
  });

  function isActiveRoute(item: NavigationItem) {
    const { fullPath } = router.currentRoute.value;

    if (fullPath.startsWith("/v2/profile")) {
      const path = fullPath.replace("/v2/profile", "");

      return item.slug === path.split("/")[1];
    }

    return item.slug === fullPath.split("/")[2];
  }

  function handleImageError(event: Event) {
    console.error("Image failed to load:", event);
  }

const __returned__ = { props, navigation, userData, navigationWithAccess, accessibleItemsCount, isActiveRoute, handleImageError, computed, ref, toRefs, watchEffect, get router() { return router }, get OriginalNavigationItem() { return OriginalNavigationItem }, get store() { return store }, get hasRequiredTier() { return hasRequiredTier } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})